export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Regular.560abebc473b983d4ea763b075e96390.woff";